// Base
import { useEffect } from 'react'
import { useRouter } from 'next/router'

// Redux
import { useAppDispatch, useAppSelector } from '@redux/hooks'
import { showLoadingScreen } from '@redux/slices/utilitiesSlice'

// Components
import Box from '@components/helpers/box/Box'
import Flex from '@components/helpers/flex/Flex'
import LoadingSpinner from '@components/helpers/loadingSpinner/LoadingSpinner'

// Styles
import styles from './LoadingScreen.module.sass'

const LoadingScreen = () => {
  const router = useRouter()
  const dispatch = useAppDispatch()

  const { loadingScreen } = useAppSelector((state) => state.utilities)

  useEffect(() => {
    if (loadingScreen) {
      dispatch(showLoadingScreen(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.route])

  if (!loadingScreen) {
    return null
  }

  return (
    <Box backgroundColor="black" opacity={50} className={styles.loader}>
      <Flex alignItems="center" justifyContent="center" fullHeight>
        <LoadingSpinner size="md" color="white" />
      </Flex>
    </Box>
  )
}

export default LoadingScreen
